import { GenericAPICall } from 'api/genericAPICall';
import { LogStream } from 'generics/common';
import { SettingsInjections } from 'generics/settingsInjections';

LogStream.enable( "APICALLDEBUG" );

////////////////////////////////////////////
// class PrivacyAPICall
class PrivacyAPICall  extends GenericAPICall {
  normalizeResponse( resp )  {
    return resp.result || resp.response;
  }

  getInterfaceUrl()  {
    return SettingsInjections.getUsedCircuit().userstat_server;
  }
};

export function GetPrivacyModes() {
  let callPrivacy = new PrivacyAPICall("GetUnlockAccessModes");

  return callPrivacy.POST().then( (resp) =>  {
    LogStream( "APICALLDEBUG" ).info(`GetPrivacyMode - got response:`, resp);

    let modes = {};

    resp.forEach(({appId, mode}) =>  {
      modes[appId] = mode;
    });

    return modes;
  });
}

export function SetGlobalPrivacyMode( mode ) {
  let callPrivacy = new PrivacyAPICall("SetGlobalUnlockAccessMode");
      callPrivacy.append("mode", mode);

  return callPrivacy.POST().then( (resp) =>  {
    LogStream( "APICALLDEBUG" ).info(`SetGlobalPrivacyMode -> `, mode);
  });
}